import { useEffect } from 'react'
import { useMap } from 'react-map-gl/dist/es5'

const SIZE = 48

const MAP_PIN_PATH =
  'M12 21.2395C11.8179 21.0266 11.5768 20.7397 11.2945 20.3919C10.6447 19.5913 9.77908 18.4706 8.91448 17.1891C8.04892 15.9062 7.19053 14.4713 6.55005 13.0417C5.90664 11.6055 5.5 10.2113 5.5 9C5.5 5.40614 8.40614 2.5 12 2.5C15.5939 2.5 18.5 5.40614 18.5 9C18.5 10.2113 18.0934 11.6055 17.4499 13.0417C16.8095 14.4713 15.9511 15.9062 15.0855 17.1891C14.2209 18.4706 13.3553 19.5913 12.7055 20.3919C12.4232 20.7397 12.1821 21.0266 12 21.2395ZM9 9C9 10.6561 10.3439 12 12 12C13.6561 12 15 10.6561 15 9C15 7.34386 13.6561 6 12 6C10.3439 6 9 7.34386 9 9Z'

const MAP_PIN = (
  fill: string,
  stroke: string,
  opacity = 1
) => `<svg width="${SIZE}" height="${SIZE}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="${opacity}">
    <path fill-rule="evenodd" clip-rule="evenodd" d="${MAP_PIN_PATH}" fill="${fill}" stroke="${stroke}"
  /></g>
</svg>`

export const useMapPin = (BASE_ID: string, fill: string, stroke: string, opacity = 1) => {
  const { current: map } = useMap()

  const pinIconId = `${BASE_ID}_${fill}_${stroke}`

  useEffect(() => {
    if (!map) {
      return
    }

    map.on('styledata', () => {
      if (map && !map.hasImage(pinIconId)) {
        const image = new Image(SIZE, SIZE)

        image.onload = () => {
          if (map && !map.hasImage(pinIconId)) {
            map.addImage(pinIconId, image)
          }
        }

        const svgSource = MAP_PIN(fill, stroke, opacity)

        image.src = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(svgSource)
      }
    })
  }, [map, pinIconId])

  return pinIconId
}
